import { Injectable, signal } from '@angular/core';
import { User } from '../models/user.model';

// Temporary mock user — replace with real auth (Google / M365) in Phase 2
const MOCK_USER: User = {
  id: 'u1',
  name: 'Alex Johnson',
  email: 'alex.johnson@acme-corp.com',
  role: 'Security Administrator',
  company: 'Acme Corp',
};

@Injectable({ providedIn: 'root' })
export class AuthService {
  readonly currentUser = signal<User | null>(MOCK_USER);

  logout(): void {
    // Placeholder: clear user and redirect to login when auth is wired
    this.currentUser.set(null);
    window.location.href = '/login';
  }
}
